export default {"src":"/_next/static/media/icon_zapier.72bf2ffd.svg","height":42,"width":42};